import { v4 as uuidv4 } from "uuid";

const { createContext, useState, useContext, useEffect } = require("react");

const BASE_URL = "https://xiaolifaa.com/fsend/user";

const UserAuthContext = createContext();

export function UserProvider({ children }) {
  const [user, setUser] = useState(() => {
    const localUser = localStorage.getItem("user");
    return localUser ? JSON.parse(localUser) : null;
  });

  const [deviceId, setDeviceId] = useState(() => {
    let localId = localStorage.getItem("device-id");
    if (!localId) {
      localId = "web-" + uuidv4();
      localStorage.setItem("device-id", localId);
    }
    return localId;
  });

  console.log(`BASE_URL:${BASE_URL}`);

  // 苹果登录信息初始化
  useEffect(() => {
    if (window.AppleID) {
      window.AppleID.auth.init({
        clientId: "com.xiaolifaa.FastFileTransferWeb",
        scope: "name email",
        redirectURI: "https://fsend.cn/apple_login_callback",
        state: "test", // 可选，防止 CSRF 攻击
        nonce: `${Date.now()}`, // 时间戳
        usePopup: true, // 使用弹出窗口进行登录
      });
    }
  }, []);

  useEffect(() => {
    document.addEventListener("AppleIDSignInOnSuccess", (event) => {
      console.log("AppleIDSignInOnSuccess event:", event);
      // Handle successful response.
      console.log(event.detail.data);
    });

    // Listen for authorization failures.
    document.addEventListener("AppleIDSignInOnFailure", (event) => {
      console.log("AppleIDSignInOnFailure event:", event);
      // Handle error.
      console.log(event.detail.error);
    });

    return () => {
      document.removeEventListener("AppleIDSignInOnSuccess", () => {});
      document.removeEventListener("AppleIDSignInOnFailure", () => {});
    };
  }, []);

  async function loginWithApple({ identityToken, fullName }) {
    const data = {
      identityToken: identityToken,
      deviceId: deviceId,
      fullName: fullName,
    };

    try {
      const response = await fetch(`${BASE_URL}/login_with_apple`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const res = await response.json();
      console.log("loginWithApple res:", res);
      if (res.code === 0) {
        localStorage.setItem("user", JSON.stringify(res.data));
        // Update user state
        setUser(res.data);
      } else {
        throw new Error(res.message || "登录失败");
      }
    } catch (error) {
      console.error("Login failed:", error);
      throw error; // Re-throw the error to be handled by the caller
    }
  }

  async function loginWechatWitCode(code) {
    const data = {
      code: code,
      deviceId: deviceId,
      fromWeb: true,
    };

    try {
      const response = await fetch(`${BASE_URL}/login_with_wechat`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const res = await response.json();
      console.log("loginWechatWitCode res:", res);
      if (res.code === 0) {
        localStorage.setItem("user", JSON.stringify(res.data));
        // Update user state
        setUser(res.data);
      } else {
        throw new Error(res.message || "登录失败");
      }
    } catch (error) {
      console.error("Login failed:", error);
      throw error; // Re-throw the error to be handled by the caller
    }
  }

  async function logout() {
    const response = await fetch(`${BASE_URL}/logout`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
    const res = await response.json();
    console.log("logout res:", res);
    if (res.code === 0) {
      localStorage.removeItem("user");
      setUser(null);
    }
  }

  useEffect(() => {
    async function checkToken() {
      const response = await fetch(`${BASE_URL}/check_token`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      });
      if (response.status === 401) {
        console.log("Token expired, logging out...");
        localStorage.removeItem("user");
        setUser(null);
        return;
      }
    }

    if (user) {
      checkToken();
    }
  }, [user]);

  return (
    <UserAuthContext.Provider
      value={{ user: user, loginWechatWitCode: loginWechatWitCode, logout: logout, loginWithApple: loginWithApple }}
    >
      {children}
    </UserAuthContext.Provider>
  );
}

export const useUser = () => useContext(UserAuthContext);
